import Shimmer from 'Components/shimmer'
import PropTypes from 'prop-types'

const MaleDailyVideoShimmer = ({ isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div
        className={`maledaily-video-shimmer maledaily-video-shimmer--${device}`}
      >
        <div
          className={`maledaily-video-shimmer__title maledaily-video-shimmer__title--${device}`}
        >
          <Shimmer width={isMobile ? '280px' : '300px'} height="12px" />
        </div>
        <div
          className={`maledaily-video-shimmer__slider maledaily-video-shimmer__slider--${device}`}
        >
          <div
            className={`maledaily-video-shimmer__item maledaily-video-shimmer__item--${device}`}
          >
            <Shimmer
              width={isMobile ? '300px' : '617px'}
              height={isMobile ? '168px' : '327px'}
            />
          </div>
          <div
            className={`maledaily-video-shimmer__item maledaily-video-shimmer__item--${device}`}
          >
            <Shimmer
              width={isMobile ? '300px' : '617px'}
              height={isMobile ? '168px' : '327px'}
            />
            <div className="maledaily-video-shimmer__title-box">
              <Shimmer width={isMobile ? '300px' : '617px'} height="12px" />
              <Shimmer width={isMobile ? '300px' : '617px'} height="12px" />
            </div>
          </div>
          <div
            className={`maledaily-video-shimmer__item maledaily-video-shimmer__item--${device}`}
          >
            <Shimmer
              width={isMobile ? '300px' : '617px'}
              height={isMobile ? '168px' : '327px'}
            />
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .maledaily-video-shimmer {
            width: 100%;
            margin: auto;
            background-image: url('/images/male_daily_rectangle.svg');
            background-size: 100% 100%;
            padding: var(--space-48) 0px var(--space-80) 0px;
          }

          .maledaily-video-shimmer--mobile {
            background-image: none;
            padding: 0px;
          }

          .maledaily-video-shimmer__slider {
            width: 100%;
            display: flex;
            gap: 40px;
            overflow: hidden;
            justify-content: center;
          }

          .maledaily-video-shimmer__slider---mobile {
            gap: 12px;
          }

          .maledaily-video-shimmer__title {
            display: flex;
            justify-content: center;
            margin-bottom: var(--space-40);
          }

          .maledaily-video-shimmer__title--mobile {
            margin-bottom: var(--space-20);
          }

          .maledaily-video-shimmer__title-box {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .maledaily-video-shimmer__item {
            width: 100%;
            max-width: 617px;
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .maledaily-video-shimmer__item--mobile {
            width: 300px;
            gap: 8px;
          }
        `}
      </style>
    </>
  )
}

MaleDailyVideoShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyVideoShimmer
